import type { SessionStatus } from '../types';

const STATUS_STYLES: Record<SessionStatus, string> = {
  initializing: 'bg-yellow-50 border-yellow-300 text-yellow-700',
  ready: 'bg-green-50 border-green-300 text-green-700',
  running: 'bg-blue-50 border-blue-300 text-blue-700 animate-pulse',
  paused: 'bg-orange-50 border-orange-300 text-orange-700',
  stopped: 'bg-gray-100 border-gray-300 text-gray-500',
  archived: 'bg-purple-50 border-purple-300 text-purple-700',
  error: 'bg-red-50 border-red-300 text-red-700',
};

const STATUS_LABELS: Record<SessionStatus, string> = {
  initializing: 'Inicializando',
  ready: 'Pronto',
  running: 'Executando',
  paused: 'Pausado',
  stopped: 'Parado',
  archived: 'Arquivado',
  error: 'Erro',
};

export function StatusBadge({ status }: { status: SessionStatus }) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border ${STATUS_STYLES[status] || STATUS_STYLES.stopped}`}
    >
      {STATUS_LABELS[status] || status}
    </span>
  );
}
